export default __webpack_public_path__ + "static/media/p14.a7312bd1.jpg";